module.exports = __webpack_public_path__ + "static/practice-05-cover-2dcb717b1a4324f1eef7b9f50835179d.jpg";